module.exports = __webpack_public_path__ + "static/img/icon_talk.1c6b368b.svg";